import React from 'react';
import './PageSpacer.css';

const PageSpacer = () => {
  return <div className="page-spacer"></div>;
};

export default PageSpacer;